<script setup>
import { SecondaryButton } from "@Components/Button";
import { FormInput, FormLabel, FormTextarea } from "@Components/Form";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";

const props = defineProps({
    title: String,
    description: String,
    examples: Array,
    keywordLabel: String,
    keywordPlaceholder: String,
    keywordHelp: String,
    lengthLabel: String,
    lengthPlaceholder: String,
    lengthHelp: String,
    customInstructionsLabel: String,
    customInstructionsPlaceholder: String,
    customInstructionsHelp: String,
});

const { t: __ } = useI18n();

const model = defineModel();
</script>
<template>
    <div class="flex flex-col space-y-6">
        <FormInput v-model="model.keyword" :label="keywordLabel" :help="keywordHelp" :placeholder="keywordPlaceholder" :errors="model.getErrors('keyword')" />

        <div v-if="examples.length > 0">
            <div class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
                {{ examples.length === 1 ? __("Exemple de titre :") : __("Exemples de titre :") }}
            </div>
            <div class="mt-1 space-y-0.5">
                <div v-for="example in examples" class="text-gray-600 dark:text-gray-400">{{ example }}</div>
            </div>
        </div>

        <FormInput
            v-model="model.length"
            :label="lengthLabel"
            type="number"
            :help="lengthHelp"
            :placeholder="lengthPlaceholder"
            :errors="model.getErrors('length')" />

        <Disclosure as="div" class="mt-2" v-slot="{ open }">
            <div class="flex flex-col space-y-2">
                <div class="flex justify-between items-center gap-3">
                    <FormLabel for="custom-instructions">{{ customInstructionsLabel }}</FormLabel>
                    <DisclosureButton :as="SecondaryButton" :icon="open ? ChevronUpIcon : ChevronDownIcon" type="button" />
                </div>
                <DisclosurePanel>
                    <FormTextarea
                        id="custom-instructions"
                        v-model="model.custom_instructions"
                        rows="5"
                        :help="customInstructionsHelp"
                        :placeholder="customInstructionsPlaceholder"
                        :errors="model.getErrors('custom_instructions')" />
                </DisclosurePanel>
            </div>
        </Disclosure>
    </div>
</template>
